<template>
  <a-icon-sheet-card
    title="Recruiting.Dashboard.JobInterviewsTitle"
    :count="data.count"
  >
    <div
      v-if="empty"
      v-t="'Recruiting.Dashboard.JobInterviewsNoInterviews'"
      class="p-3"
    />
    <div
      v-for="(interviews, monthOfInterviews) in groupedInterviews"
      v-else
      :key="monthOfInterviews"
    >
      <div class="p-3 h6" v-text="monthOfInterviews" />
      <hr class="m-0" />
      <ul class="list-group list-group-flush">
        <li
          v-for="(iterview, iterviewKey) in interviews"
          :key="iterviewKey"
          :class="isTodayClass(iterview)"
          class="list-group-item dashboard-dashlet-list-item action-item"
          @click="itemClicked(iterview)"
        >
          <div class="row">
            <div class="col-auto py-0">
              <img
                :src="getApplicantImage(iterview)"
                :alt="iterview.applicantName"
                class="dashboard-dashlet-image-thumbnail"
              />
            </div>
            <div class="col py-0">
              <a-dashlet-list-item-title>
                <span slot="title" v-text="iterview.applicantName" />
              </a-dashlet-list-item-title>
              <div
                class="text-wrap text-muted"
                v-text="iterview.jobPostingTitle"
              />
              <div class="text-wrap text-muted" v-text="iterview.type" />
            </div>
            <div class="col-auto py-0 text-center text-muted">
              <div v-text="$dtFormat(new Date(iterview.dateTime), 'dddd')" />
              <div
                class="lead"
                v-text="$dtFormat(new Date(iterview.dateTime), 'd')"
              />
              <div>
                <i class="pf-clock-o"></i>
                <span v-text="getInterviewTime(iterview.dateTime)" />
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <template #actions>
      <a
        v-t="'Recruiting.Dashboard.ShowAll'"
        :disabled="empty"
        :class="{ 'text-muted text-decoration-none': empty }"
        href="javascript:void(0)"
        @click="goToOverview()"
      />
    </template>
  </a-icon-sheet-card>
</template>

<script>
import IconSheetCard from "+/components/card/IconSheetCard.vue";
import DashletListItemTitle from "~/recruiting-system/components/dashboard/DashletListItemTitle.vue";
import utils from "./utils/utils.js";
import _ from "lodash";

export default {
  components: {
    "a-icon-sheet-card": IconSheetCard,
    "a-dashlet-list-item-title": DashletListItemTitle
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    groupedInterviews() {
      const groupedInterviews = _.groupBy(this.data.jobInterviews, interview =>
        this.$dtFormat(new Date(interview.dateTime), "MMMM yyyy")
      );
      return groupedInterviews;
    },
    empty() {
      return this.data.count < 1;
    }
  },
  methods: {
    getApplicantImage(interview) {
      return `/persis/main?fn=bm.img&bwg_refnr=${interview.applicationId}`;
    },
    getInterviewTime(dateTime) {
      const interviewTime = this.$dtFormat(new Date(dateTime), "HH:mm");
      return this.$t("Recruiting.Dashboard.JobInterviewsClock", [
        interviewTime
      ]);
    },
    isTodayClass(interview) {
      if (
        this.$dtFormat(new Date()) ==
        this.$dtFormat(new Date(interview.dateTime))
      )
        return "highlight";
    },
    itemClicked(iterview) {
      const route = `/main/bm.akten/gespraeche?einzelansicht=1&bwg_refnr=${iterview.applicationId}`;
      this.$router.push(route);
    },
    goToOverview() {
      if (this.empty) {
        return;
      }
      utils.delZSearchSession("iBM_VORST_FK");
      const route = `/main/bm.vorst`;
      this.$router.push(route);
    }
  }
};
</script>
